import './scrollToTop';



// WEBPACK FOOTER //
// ./scripts/elements/scrollToTop/index.js